import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
    <path
      d="M12 3l2.021 6.219h6.539l-5.29 3.843 2.021 6.219L12 15.438l-5.29 3.843 2.021-6.219-5.29-3.843h6.539L12 3z"
      strokeLinejoin="round"
    />
  </svg>
);
